
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'AnimationToggle',
  emits: ['update:animationToggle'],
  props: {
    animationToggle: Boolean
  },
  setup(_, { emit }) {
    const animationToggle = ref<boolean>();
    const emitAnimationToggle = () => {
      emit('update:animationToggle', animationToggle.value);
    };

    return {
      animationToggle,
      emitAnimationToggle
    };
  }
});
